import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    minWidth: 120,
    marginTop: theme.spacing(2),
  },
}));
